'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = makeSingle;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function makeSingle(baseClass) {
    var SingleObjectResource = function (_baseClass) {
        _inherits(SingleObjectResource, _baseClass);

        function SingleObjectResource() {
            _classCallCheck(this, SingleObjectResource);

            return _possibleConstructorReturn(this, (SingleObjectResource.__proto__ || Object.getPrototypeOf(SingleObjectResource)).apply(this, arguments));
        }

        _createClass(SingleObjectResource, [{
            key: 'fetch',
            value: function fetch(kwargs, query) {
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'get';

                var thePath = this.buildThePath(kwargs);
                return this.handleRequest(this.createRequest(method, thePath, query));
            }
        }, {
            key: 'head',
            value: function head(kwargs, query) {
                return this.fetch(kwargs, query, 'head');
            }
        }, {
            key: 'post',
            value: function post(kwargs, data, query) {
                var method = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'post';

                var thePath = this.buildThePath(kwargs);

                return this.handleRequest(this.createRequest(method, thePath, query, data || {}));
            }
        }, {
            key: 'patch',
            value: function patch(kwargs, data, query) {
                return this.post(kwargs, data, query, 'patch');
            }
        }, {
            key: 'put',
            value: function put(kwargs, data, query) {
                return this.post(kwargs, data, query, 'put');
            }
        }, {
            key: 'del',
            value: function del(kwargs, data, query) {
                return this.post(kwargs, data, query, 'del');
            }
        }]);

        return SingleObjectResource;
    }(baseClass);

    return SingleObjectResource;
}


//////////////////
// WEBPACK FOOTER
// ../~/tg-resources/dist/single.js
// module id = 774
// module chunks = 0